import { RoundFlag } from "./RoundFlag";

export function GBFlag() {
  return (
    <RoundFlag code="gb">
      <rect width="20" height="20" fill="#012169" />
      <path d="M0 0L20 20M20 0L0 20" stroke="white" strokeWidth="4" />
      <path d="M0 0L20 20M20 0L0 20" stroke="#C8102E" strokeWidth="2" />
      <path d="M10 0V20M0 10H20" stroke="white" strokeWidth="6" />
      <path d="M10 0V20M0 10H20" stroke="#C8102E" strokeWidth="3" />
    </RoundFlag>
  );
}
